/* =========================================================================
   MK - Master Kit JS
   Consolidado de todos los módulos custom del theme.
   Cada módulo tiene su bloque delimitado abajo.
   Auto-init sobre TODAS las instancias en la página (querySelectorAll + forEach).
   ========================================================================= */

(function () {
  'use strict';

  function initAll() {

    /* ===============================================================
       MÓDULO: hero-slider-v2   (selector: .hs2)
       =============================================================== */
    document.querySelectorAll('.hs2').forEach(function (wrap) {
      if (wrap.dataset.mkInit === '1') return;
      wrap.dataset.mkInit = '1';

      var track = wrap.querySelector('[data-track]');
      var slides = wrap.querySelectorAll('[data-slide]');
      if (!track || !slides.length) return;

      var total = slides.length;
      var idx = 0;
      var autoplay = wrap.dataset.autoplay === 'true';
      var speed = parseInt(wrap.dataset.autoplaySpeed, 10) || 5000;
      var pauseHover = wrap.dataset.pauseHover === 'true';
      var pauseVideo = wrap.dataset.pauseVideo === 'true';
      var loop = wrap.dataset.loop === 'true';
      var timer = null;
      var progressEl = wrap.querySelector('[data-progress]');

      var dotsWrap = wrap.querySelector('[data-dots]');
      var dots = [];
      if (dotsWrap) {
        for (var i = 0; i < total; i++) {
          var d = document.createElement('button');
          d.className = 'hs2__dot';
          d.setAttribute('type', 'button');
          d.setAttribute('aria-label', 'Slide ' + (i + 1));
          d.dataset.dot = i;
          dotsWrap.appendChild(d);
          dots.push(d);
        }
      }

      var blurredImg = wrap.querySelector('[data-blurred-img]');

      function updateBlurred() {
        if (!blurredImg) return;
        var current = slides[idx];
        if (!current) return;
        var src = current.getAttribute('data-blurred-src');
        if (src && blurredImg.getAttribute('src') !== src) {
          blurredImg.setAttribute('src', src);
        }
      }

      function go(n) {
        if (n < 0) n = loop ? total - 1 : 0;
        if (n >= total) n = loop ? 0 : total - 1;
        idx = n;
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        restartProgress();
        handleVideos();
        handlePauseOnVideo();
        updateBlurred();
      }
      function next() { go(idx + 1); }
      function prev() { go(idx - 1); }

      function handlePauseOnVideo() {
        if (!pauseVideo || !autoplay) return;
        var current = slides[idx];
        if (current && current.dataset.isVideo === 'true') {
          stopTimer();
          if (progressEl) { progressEl.style.transition = 'none'; progressEl.style.width = '0%'; }
        } else {
          startTimer();
        }
      }

      var prevBtn = wrap.querySelector('[data-nav="prev"]');
      var nextBtn = wrap.querySelector('[data-nav="next"]');
      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); resetTimer(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { next(); resetTimer(); });

      dots.forEach(function (d) {
        d.addEventListener('click', function () { go(parseInt(d.dataset.dot, 10)); resetTimer(); });
      });

      function startTimer() {
        if (!autoplay || total < 2) return;
        stopTimer();
        timer = setInterval(next, speed);
      }
      function stopTimer() { if (timer) { clearInterval(timer); timer = null; } }
      function resetTimer() { stopTimer(); startTimer(); }

      function restartProgress() {
        if (!progressEl || !autoplay) return;
        progressEl.style.transition = 'none';
        progressEl.style.width = '0%';
        void progressEl.offsetWidth;
        progressEl.style.transition = 'width ' + speed + 'ms linear';
        progressEl.style.width = '100%';
      }

      if (pauseHover && autoplay) {
        wrap.addEventListener('mouseenter', stopTimer);
        wrap.addEventListener('mouseleave', startTimer);
      }

      var startX = 0, deltaX = 0;
      track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; deltaX = 0; }, { passive: true });
      track.addEventListener('touchmove', function (e) { deltaX = e.touches[0].clientX - startX; }, { passive: true });
      track.addEventListener('touchend', function () {
        if (Math.abs(deltaX) > 40) { if (deltaX < 0) next(); else prev(); resetTimer(); }
      });

      function applyMobileWidths() {
        if (window.innerWidth >= 750) return;
        wrap.querySelectorAll('.hs2__content').forEach(function (c) {
          var w = c.dataset.mobileWidth;
          if (w) c.style.width = w + '%';
        });
      }

      function handleVideos() {
        // YouTube iframes: recargar cuando el slide queda inactivo (mata autoplay)
        wrap.querySelectorAll('.hs2__video iframe').forEach(function (frame) {
          var slide = frame.closest('[data-slide]');
          if (!slide) return;
          if (slide !== slides[idx]) {
            var src = frame.getAttribute('src');
            if (src && src.indexOf('&_reload') === -1) frame.setAttribute('src', src);
          }
        });
        // Video nativo: pausar cuando el slide queda inactivo, reproducir cuando activo
        wrap.querySelectorAll('video.hs2__video-native').forEach(function (v) {
          var slide = v.closest('[data-slide]');
          if (!slide) return;
          if (slide === slides[idx]) {
            var p = v.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
          } else {
            v.pause();
            try { v.currentTime = 0; } catch (e) {}
          }
        });
      }

      applyMobileWidths();
      window.addEventListener('resize', applyMobileWidths);
      go(0);
      startTimer();
    });


    /* ===============================================================
       MÓDULO: video-grid-v2   (selector: .vgd)
       =============================================================== */
    document.querySelectorAll('.vgd').forEach(function (section) {
      if (section.dataset.mkInit === '1') return;
      section.dataset.mkInit = '1';

      section.querySelectorAll('[data-card]').forEach(function (card) {
        var nativeVideo = card.querySelector('[data-video-native]');
        var playNative = card.querySelector('[data-play-native]');
        var pauseNative = card.querySelector('[data-pause-native]');

        if (nativeVideo && playNative && pauseNative) {
          var play = function () {
            nativeVideo.play().then(function () {
              playNative.style.display = 'none';
              pauseNative.style.display = 'flex';
              card.dataset.playing = '1';
            }).catch(function () {});
          };
          var pause = function () {
            nativeVideo.pause();
            playNative.style.display = 'flex';
            pauseNative.style.display = 'none';
            delete card.dataset.playing;
          };
          playNative.addEventListener('click', play);
          pauseNative.addEventListener('click', pause);
          nativeVideo.addEventListener('click', function () {
            if (nativeVideo.paused) { play(); } else { pause(); }
          });
          nativeVideo.addEventListener('ended', function () {
            playNative.style.display = 'flex';
            pauseNative.style.display = 'none';
            delete card.dataset.playing;
          });
        }

        var embedWrap = card.querySelector('[data-embed]');
        var playEmbed = card.querySelector('[data-play-embed]');
        if (embedWrap && playEmbed) {
          playEmbed.addEventListener('click', function () {
            var src = embedWrap.getAttribute('data-embed-src');
            if (!src) return;
            var iframe = document.createElement('iframe');
            iframe.src = src;
            iframe.setAttribute('frameborder', '0');
            iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
            iframe.setAttribute('allowfullscreen', '');
            iframe.className = 'vgd__video vgd__iframe';
            embedWrap.innerHTML = '';
            embedWrap.appendChild(iframe);
            playEmbed.style.display = 'none';
            card.dataset.playing = '1';
          });
        }
      });
    });


    /* ===============================================================
       MÓDULO: collection-carousel-v2   (selector: .ccv2-section)
       Nota: arrows en desktop, scroll horizontal siempre.
       =============================================================== */
    document.querySelectorAll('.ccv2-section').forEach(function (wrap) {
      if (wrap.dataset.mkInit === '1') return;
      wrap.dataset.mkInit = '1';

      var track = wrap.querySelector('[data-track]');
      var btns = wrap.querySelectorAll('[data-nav]');
      if (!track || !btns.length) return;

      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = btn.getAttribute('data-nav');
          var slide = track.querySelector('.ccv2-slide');
          if (!slide) return;
          var step = slide.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0);
          track.scrollBy({ left: dir === 'next' ? step : -step, behavior: 'smooth' });
        });
      });
    });


    /* ===============================================================
       MÓDULO: product-showcase-v1 (section vitrina)
       Selector: id="psc-<section.id>", contiene [data-psc-track] y [data-psc-nav]
       =============================================================== */
    document.querySelectorAll('[id^="psc-"]').forEach(function (root) {
      if (root.dataset.mkInit === '1') return;
      var track = root.querySelector('[data-psc-track]');
      if (!track) return;
      root.dataset.mkInit = '1';

      // Shuffle Fisher-Yates si el track tiene data-psc-shuffle="true"
      if (track.getAttribute('data-psc-shuffle') === 'true') {
        var cells = Array.prototype.slice.call(track.children);
        for (var i = cells.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          track.appendChild(cells[j]);
          cells.splice(j, 1);
        }
      }

      var isCarousel = track.classList.contains('psc-products--carousel');
      var navs = root.querySelectorAll('[data-psc-nav]');

      function getStep() {
        var cell = track.querySelector('.psc-cell');
        if (!cell) return 0;
        return cell.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0);
      }

      function advance(dir) {
        var step = getStep();
        if (!step) return;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        if (dir === 'next' && atEnd) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: dir === 'next' ? step : -step, behavior: 'smooth' });
        }
      }

      navs.forEach(function (btn) {
        if (!isCarousel) { btn.style.display = 'none'; return; }
        btn.addEventListener('click', function () {
          advance(btn.getAttribute('data-psc-nav'));
        });
      });

      // ── Autoplay ─────────────────────────────────────────────
      if (isCarousel) {
        var carouselEl = root.querySelector('.psc-carousel') || root;
        if (carouselEl.getAttribute('data-psc-autoplay') === 'true') {
          var speed = parseInt(carouselEl.getAttribute('data-psc-autoplay-speed'), 10) || 4000;
          var pauseHover = carouselEl.getAttribute('data-psc-pause-hover') === 'true';
          var timer = null;
          var paused = false;

          function start() {
            if (timer) return;
            timer = setInterval(function () {
              if (!paused && !document.hidden) advance('next');
            }, speed);
          }
          function stop() {
            if (!timer) return;
            clearInterval(timer);
            timer = null;
          }

          if (pauseHover) {
            carouselEl.addEventListener('mouseenter', function () { paused = true; });
            carouselEl.addEventListener('mouseleave', function () { paused = false; });
          }
          // Pausar mientras el usuario arrastra/scrollea manualmente
          var userScrollTimeout = null;
          track.addEventListener('scroll', function () {
            paused = true;
            clearTimeout(userScrollTimeout);
            userScrollTimeout = setTimeout(function () { paused = false; }, 1200);
          }, { passive: true });

          start();
        }
      }
    });


    /* ===============================================================
       MÓDULO: mk-menu   (selector: .mkmenu)
       Header block con toggle mobile + acordeón sub-items.
       =============================================================== */
    document.querySelectorAll('.mkmenu').forEach(function (nav) {
      if (nav.dataset.mkInit === '1') return;
      nav.dataset.mkInit = '1';

      // Toggle mobile (hamburger)
      var toggle = nav.querySelector('[data-mkmenu-toggle]');
      if (toggle) {
        toggle.addEventListener('click', function () {
          var open = nav.classList.toggle('is-open');
          toggle.setAttribute('aria-expanded', String(open));
        });
      }

      // Sub-items: mobile abre por click. Desktop usa hover (CSS).
      nav.querySelectorAll('.mkmenu__item--has-children > .mkmenu__link').forEach(function (link) {
        link.addEventListener('click', function (e) {
          // Solo interceptar en mobile
          if (window.innerWidth >= 750) return;
          // Si el link tiene href real, dejamos que navegue solo si el item ya estaba abierto
          var item = link.closest('.mkmenu__item');
          var isOpen = item.classList.contains('is-open');
          if (link.tagName === 'A' && link.getAttribute('href') && link.getAttribute('href') !== '#') {
            if (!isOpen) {
              e.preventDefault();
              item.classList.add('is-open');
              link.setAttribute('aria-expanded', 'true');
            }
            return;
          }
          e.preventDefault();
          item.classList.toggle('is-open');
          link.setAttribute('aria-expanded', String(!isOpen));
        });
      });

      // Cerrar drawer al click fuera (mobile)
      document.addEventListener('click', function (e) {
        if (window.innerWidth >= 750) return;
        if (!nav.contains(e.target)) {
          nav.classList.remove('is-open');
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
        }
      });
    });


    /* ===============================================================
       MÓDULO: faq-v1   (selector: .faqv)
       =============================================================== */
    document.querySelectorAll('.faqv').forEach(function (root) {
      if (root.dataset.mkInit === '1') return;
      root.dataset.mkInit = '1';

      var allowMultiple = root.getAttribute('data-allow-multiple') === 'true';
      root.querySelectorAll('.faqv__q').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.faqv__item');
          var willOpen = !item.classList.contains('is-open');

          if (willOpen && !allowMultiple) {
            root.querySelectorAll('.faqv__item.is-open').forEach(function (it) {
              if (it !== item) {
                it.classList.remove('is-open');
                var b = it.querySelector('.faqv__q');
                if (b) b.setAttribute('aria-expanded', 'false');
              }
            });
          }
          item.classList.toggle('is-open', willOpen);
          btn.setAttribute('aria-expanded', String(willOpen));
        });
      });
    });

    /* ===============================================================
       MÓDULO: mk-store-locator   (selector: .mksl)
       Cierra las demás <details> cuando se abre una (single-open).
       =============================================================== */
    document.querySelectorAll('.mksl').forEach(function (root) {
      if (root.dataset.mkInit === '1') return;
      root.dataset.mkInit = '1';

      var allowMultiple = root.getAttribute('data-allow-multiple') === 'true';
      if (allowMultiple) return;

      root.querySelectorAll('.mksl__item').forEach(function (detail) {
        detail.addEventListener('toggle', function () {
          if (!detail.open) return;
          root.querySelectorAll('.mksl__item[open]').forEach(function (other) {
            if (other !== detail) other.removeAttribute('open');
          });
        });
      });
    });

    /* ===============================================================
       MÓDULO: mk-msearch  (selector: mk-msearch)
       Panel de búsqueda mobile con predictive search de Shopify.
       - Toggle icono lupa
       - Fetch a /search/suggest.json al tipear (debounce 250ms)
       - Enter o submit navega a /search?q=...
       - Cierra con X, click fuera, o ESC
       =============================================================== */
    document.querySelectorAll('mk-msearch').forEach(function (root) {
      if (root.dataset.mkInit === '1') return;
      root.dataset.mkInit = '1';

      var toggle = root.querySelector('[data-mk-msearch-toggle]');
      var panel = root.querySelector('[data-mk-msearch-panel]');
      var input = root.querySelector('[data-mk-msearch-input]');
      var closeBtn = root.querySelector('[data-mk-msearch-close]');
      var resultsEl = root.querySelector('[data-mk-msearch-results]');
      if (!toggle || !panel || !input) return;

      function openPanel() {
        panel.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
        setTimeout(function () { input.focus(); }, 30);
      }
      function closePanel() {
        panel.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        if (resultsEl) { resultsEl.hidden = true; resultsEl.innerHTML = ''; }
      }

      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        if (panel.hidden) openPanel(); else closePanel();
      });
      if (closeBtn) closeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        closePanel();
      });
      panel.addEventListener('click', function (e) { e.stopPropagation(); });
      document.addEventListener('click', function (e) {
        if (!panel.hidden && !root.contains(e.target)) closePanel();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !panel.hidden) closePanel();
      });

      /* -- Predictive search -- */
      function renderResults(products, term) {
        if (!resultsEl) return;
        if (!products.length) {
          resultsEl.innerHTML = '<div class="mk-msearch__empty">Sin resultados para "' + escapeHtml(term) + '"</div>';
          resultsEl.hidden = false;
          return;
        }
        var html = '<ul class="mk-msearch__list">';
        products.forEach(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
          var priceHtml = '';
          if (p.price != null) {
            priceHtml = '<span class="mk-msearch__price">' + formatMoney(p.price) + '</span>';
            var cmp = p.compare_at_price_max || p.compare_at_price_min || p.compare_at_price;
            if (cmp != null && Number(cmp) > Number(p.price)) {
              priceHtml += '<span class="mk-msearch__compare">' + formatMoney(cmp) + '</span>';
            }
          }
          html += '<li class="mk-msearch__item"><a class="mk-msearch__link" href="' + p.url + '">';
          if (img) html += '<img class="mk-msearch__thumb" src="' + img + '&width=80" alt="" loading="lazy">';
          html += '<div class="mk-msearch__text"><span class="mk-msearch__title">' + escapeHtml(p.title) + '</span>' + priceHtml + '</div>';
          html += '</a></li>';
        });
        html += '</ul>';
        html += '<a class="mk-msearch__viewall" href="/search?q=' + encodeURIComponent(term) + '&options%5Bprefix%5D=last">Ver todos los resultados para "' + escapeHtml(term) + '"</a>';
        resultsEl.innerHTML = html;
        resultsEl.hidden = false;
      }

      function escapeHtml(s) {
        return String(s).replace(/[&<>"']/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
      }

      function formatMoney(raw) {
        // /search/suggest.json devuelve price como string en la moneda del shop,
        // ya en unidades enteras (para CLP: "139990"). NO son centavos.
        var n = Number(raw);
        if (!isFinite(n)) return '';
        try {
          return n.toLocaleString('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 });
        } catch (e) {
          return '$' + Math.round(n).toLocaleString('es-CL');
        }
      }

      var fetchTimer = null;
      var lastQuery = '';
      var abortCtrl = null;

      input.addEventListener('input', function () {
        var q = input.value.trim();
        clearTimeout(fetchTimer);
        if (q.length < 2) {
          if (resultsEl) { resultsEl.hidden = true; resultsEl.innerHTML = ''; }
          return;
        }
        if (q === lastQuery) return;
        fetchTimer = setTimeout(function () { doFetch(q); }, 250);
      });

      function doFetch(q) {
        lastQuery = q;
        if (abortCtrl) abortCtrl.abort();
        abortCtrl = new AbortController();
        var url = '/search/suggest.json?q=' + encodeURIComponent(q)
          + '&resources[type]=product'
          + '&resources[limit]=6'
          + '&resources[options][unavailable_products]=last'
          + '&resources[options][fields]=title,vendor,product_type,variants.title';
        fetch(url, { signal: abortCtrl.signal, headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
            renderResults(products, q);
          })
          .catch(function (err) {
            if (err.name !== 'AbortError' && resultsEl) {
              resultsEl.innerHTML = '<div class="mk-msearch__empty">Error al buscar. Intentá de nuevo.</div>';
              resultsEl.hidden = false;
            }
          });
      }
    });


    /* ===============================================================
       MÓDULO: mk-password   (selector: .mkpw)
       Despliega el formulario de contraseña abajo a la izquierda.
       Si Shopify devolvió error, el form ya viene con .is-open.
       =============================================================== */
    document.querySelectorAll('.mkpw').forEach(function (root) {
      if (root.dataset.mkInit === '1') return;
      root.dataset.mkInit = '1';

      var toggle = root.querySelector('.mkpw__toggle');
      var panel = root.querySelector('.mkpw__form');
      if (!toggle || !panel) return;

      if (panel.classList.contains('is-open')) {
        toggle.setAttribute('aria-expanded', 'true');
      }

      toggle.addEventListener('click', function () {
        var open = panel.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          var input = panel.querySelector('input');
          if (input) input.focus();
        }
      });
    });

  } // end initAll

  // Auto-init cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init cuando Shopify carga secciones dinámicamente (theme editor)
  document.addEventListener('shopify:section:load', initAll);

})();


/* ===============================================================
   MÓDULO: mkcp — Countdown promo (mk) con ventana híbrida:
     rango de fechas + días de la semana + rango horario.
   Timezone: America/Santiago.
   Estados: before | during | after → data-mkcp-state en el wrapper.
   =============================================================== */
(function () {
  var TZ = 'America/Santiago';
  var DAY_NAMES = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

  // Devuelve componentes de un Date proyectados a la timezone Chile
  function inTz(date) {
    var parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: TZ,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hour12: false, weekday: 'short'
    }).formatToParts(date);
    var out = {};
    parts.forEach(function (p) { out[p.type] = p.value; });
    // weekday viene en inglés corto: Mon, Tue, Wed, Thu, Fri, Sat, Sun
    var wd = (out.weekday || '').toLowerCase().slice(0, 3);
    // hour puede venir como "24" cuando es medianoche; lo normalizamos a "00"
    var hh = out.hour === '24' ? '00' : out.hour;
    return {
      iso: out.year + '-' + out.month + '-' + out.day,
      hh: hh, mm: out.minute, ss: out.second,
      hm: hh + ':' + out.minute,
      day: wd
    };
  }

  // Convierte fecha ISO + hora HH:MM en el timezone Chile → timestamp UTC (ms)
  function toChileTs(isoDate, hhmm) {
    // Crea un Date interpretando el ISO como UTC, luego calcula offset Chile
    // en ese instante para corregir. Es más simple usar Intl para hallar el offset.
    var hm = (hhmm || '00:00').split(':');
    // Construimos una fecha en "wall time Chile", luego usamos Intl para
    // saber a qué UTC corresponde ese wall time.
    var candidate = new Date(isoDate + 'T' + hhmm + ':00Z'); // UTC guess
    // Ver qué wall time Chile corresponde a esa fecha UTC
    var chile = inTz(candidate);
    var wallUTCms = Date.UTC(
      parseInt(isoDate.slice(0, 4), 10),
      parseInt(isoDate.slice(5, 7), 10) - 1,
      parseInt(isoDate.slice(8, 10), 10),
      parseInt(hm[0], 10),
      parseInt(hm[1], 10), 0
    );
    var chileWallUTCms = Date.UTC(
      parseInt(chile.iso.slice(0, 4), 10),
      parseInt(chile.iso.slice(5, 7), 10) - 1,
      parseInt(chile.iso.slice(8, 10), 10),
      parseInt(chile.hh, 10),
      parseInt(chile.mm, 10), 0
    );
    var offset = wallUTCms - chileWallUTCms;
    return candidate.getTime() + offset;
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function computeState(cfg, now) {
    var chile = inTz(now);
    var todayISO = chile.iso;
    var hm = chile.hm;

    var startDate = cfg.startDate || '';
    var endDate = cfg.endDate || '';
    var days = cfg.days;
    var timeStart = cfg.timeStart || '00:00';
    var timeEnd = cfg.timeEnd || '23:59';

    // Fuera del rango de fechas macro
    if (startDate && todayISO < startDate) {
      return { state: 'before', target: toChileTs(startDate, timeStart) };
    }
    if (endDate && todayISO > endDate) {
      return { state: 'after', target: 0 };
    }

    // Dentro del rango macro — chequear día y hora
    var dayOk = !days.length || days.indexOf(chile.day) !== -1;
    var hourOk = hm >= timeStart && hm < timeEnd;

    if (dayOk && hourOk) {
      // Countdown hasta hoy timeEnd (Chile)
      return { state: 'during', target: toChileTs(todayISO, timeEnd) };
    }

    // No estamos en ventana activa → estado 'before' con target = próxima apertura
    var nextTarget = findNextStart(cfg, chile, now);
    return { state: 'before', target: nextTarget };
  }

  function findNextStart(cfg, chile, now) {
    var timeStart = cfg.timeStart || '00:00';
    var timeEnd = cfg.timeEnd || '23:59';
    var days = cfg.days;
    var startDate = cfg.startDate || '';
    var endDate = cfg.endDate || '';

    // Iterar los próximos 14 días
    for (var i = 0; i < 14; i++) {
      var iso, dayName;
      if (i === 0) {
        iso = chile.iso;
        dayName = chile.day;
      } else {
        var d = new Date(chile.iso + 'T12:00:00Z');
        d.setUTCDate(d.getUTCDate() + i);
        var y = d.getUTCFullYear();
        var m = pad(d.getUTCMonth() + 1);
        var day = pad(d.getUTCDate());
        iso = y + '-' + m + '-' + day;
        dayName = DAY_NAMES[d.getUTCDay()];
      }

      // Fuera del rango macro
      if (startDate && iso < startDate) continue;
      if (endDate && iso > endDate) break;

      // Día de la semana no habilitado
      if (days.length && days.indexOf(dayName) === -1) continue;

      // Si es hoy y ya pasó la hora de fin, saltar al siguiente día
      if (i === 0 && chile.hm >= timeEnd) continue;

      return toChileTs(iso, timeStart);
    }
    return 0; // sin próxima ventana
  }

  function renderTimer(widget, msRemaining, format) {
    var total = Math.max(0, Math.floor(msRemaining / 1000));
    var days = Math.floor(total / 86400);
    var hrs  = Math.floor((total % 86400) / 3600);
    var min  = Math.floor((total % 3600) / 60);
    var sec  = total % 60;
    if (format === 'hms') {
      hrs = Math.floor(total / 3600);
      days = 0;
    }
    var d = widget.querySelector('[data-mkcp-days]');
    var h = widget.querySelector('[data-mkcp-hrs]');
    var mn = widget.querySelector('[data-mkcp-min]');
    var s = widget.querySelector('[data-mkcp-sec]');
    if (d) d.textContent = pad(days);
    if (h) h.textContent = pad(hrs);
    if (mn) mn.textContent = pad(min);
    if (s) s.textContent = pad(sec);
  }

  function setHeadingFor(widget, state) {
    var el = widget.querySelector('[data-mkcp-heading]');
    if (!el) return;
    var text = widget.getAttribute('data-mkcp-title-' + state) || '';
    if (text) el.textContent = text;
  }

  function initAllMkcp(scope) {
    var root = (scope && scope.querySelectorAll) ? scope : document;
    root.querySelectorAll('[data-mkcp]').forEach(function (widget) {
      if (widget.dataset.mkcpInit === '1') return;
      widget.dataset.mkcpInit = '1';

      var cfg;
      try {
        cfg = {
          startDate: widget.getAttribute('data-mkcp-start-date') || '',
          endDate:   widget.getAttribute('data-mkcp-end-date') || '',
          days:      JSON.parse(widget.getAttribute('data-mkcp-days') || '[]'),
          timeStart: widget.getAttribute('data-mkcp-time-start') || '00:00',
          timeEnd:   widget.getAttribute('data-mkcp-time-end') || '23:59'
        };
      } catch (e) { return; }

      var format = widget.getAttribute('data-mkcp-format') || 'dhms';

      function tick() {
        var now = new Date();
        var res = computeState(cfg, now);
        widget.setAttribute('data-mkcp-state', res.state);
        setHeadingFor(widget, res.state);
        if (res.target > 0) {
          renderTimer(widget, res.target - now.getTime(), format);
        }
        // Si estado during llega a 0, próximo tick recalcula y pasa a 'after' o 'before'
      }

      tick();
      // Actualizar cada segundo
      setInterval(tick, 1000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAllMkcp(); });
  } else {
    initAllMkcp();
  }
  document.addEventListener('shopify:section:load', function (e) { initAllMkcp(e.target); });
})();


/* ===============================================================
   MÓDULO: mega-menu-parent-hide — Oculta parent links cuyo título esté
   formado SOLO por símbolos (placeholders para "sin encabezado":
   rebajas usa "-", glowup usa "_" y "#"). Un título con letras o números
   nunca se oculta.
   =============================================================== */
(function () {
  var PLACEHOLDER = /^[\s\-_#.*~=+|\/\\•·–—]+$/;
  function hideDashParents(scope) {
    var root = (scope && scope.querySelectorAll) ? scope : document;
    root.querySelectorAll('.mega-menu__link-title').forEach(function (el) {
      var text = (el.textContent || '').trim();
      if (PLACEHOLDER.test(text)) {
        var parent = el.closest('.mega-menu__link--parent') || el.closest('.mega-menu__link');
        if (parent) parent.style.display = 'none';
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { hideDashParents(); });
  } else {
    hideDashParents();
  }
  document.addEventListener('shopify:section:load', function (e) { hideDashParents(e.target); });
})();


/* ===============================================================
   MÓDULO: cybertag — Reemplaza el texto de [data-mk-cybertag]
   con el cybertag de la marca publicado por DCIC (panel /shopify.php).
   Slug = dominio principal sin www ni TLD (rebajas.cl -> rebajas) (window.mkConfig.cybertagSlug,
   definido en layout/theme.liquid). Sin cybertag o ante error, queda el
   texto por defecto del ajuste mk_price_text.
   =============================================================== */
(function () {
  var slug = window.mkConfig && window.mkConfig.cybertagSlug;
  if (!slug) return;
  var tag = null;
  function apply(scope) {
    if (!tag) return;
    var root = (scope && scope.querySelectorAll) ? scope : document;
    root.querySelectorAll('[data-mk-cybertag]').forEach(function (el) {
      if (el.textContent !== tag) el.textContent = tag;
      el.hidden = false;
    });
  }
  fetch('https://dcic.afrancel.com/configuracion/shopify-config.php?slug=' + encodeURIComponent(slug) + '&t=' + Date.now())
    .then(function (r) { return r.json(); })
    .then(function (d) {
      if (!d || !d.cybertag) return;
      tag = String(d.cybertag);
      apply();
      // Tarjetas insertadas después (quick-add, carruseles, filtros)
      new MutationObserver(function () { apply(); }).observe(document.body, { childList: true, subtree: true });
    })
    .catch(function () {});
  document.addEventListener('shopify:section:load', function (e) { apply(e.target); });
})();


/* ===============================================================
   MÓDULO: mkcp-nav — Navegación prev/next para carousel del countdown.
   =============================================================== */
(function () {
  function initAllMkcpNav(scope) {
    var root = (scope && scope.querySelectorAll) ? scope : document;
    root.querySelectorAll('[id^="mkcp-"]').forEach(function (widget) {
      if (widget.dataset.mkcpNavInit === '1') return;
      widget.dataset.mkcpNavInit = '1';
      var track = widget.querySelector('[data-mkcp-track]');
      if (!track) return;
      var isCarousel = track.classList.contains('mkcp__products--carousel');
      var navs = widget.querySelectorAll('[data-mkcp-nav]');
      navs.forEach(function (btn) {
        if (!isCarousel) { btn.style.display = 'none'; return; }
        btn.addEventListener('click', function () {
          var cell = track.querySelector('.mkcp__cell');
          if (!cell) return;
          var step = cell.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0);
          var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
          var dir = btn.getAttribute('data-mkcp-nav');
          if (dir === 'next' && atEnd) {
            track.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            track.scrollBy({ left: dir === 'next' ? step : -step, behavior: 'smooth' });
          }
        });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAllMkcpNav(); });
  } else {
    initAllMkcpNav();
  }
  document.addEventListener('shopify:section:load', function (e) { initAllMkcpNav(e.target); });
})();


/* ===============================================================
   MÓDULO: mkrv-track — Registra el producto actual en localStorage.
   Corre siempre en /products/*. Guarda hasta 30 handles ordenados
   por más reciente. Usado por la sección Vistos Recientemente (mk).
   =============================================================== */
(function () {
  var KEY = 'mkRecentlyViewed';
  var MAX = 30;

  function track() {
    var m = location.pathname.match(/\/products\/([^\/\?#]+)/);
    if (!m) return;
    var handle = decodeURIComponent(m[1]);
    try {
      var list = JSON.parse(localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(list)) list = [];
      list = list.filter(function (h) { return h && h !== handle; });
      list.unshift(handle);
      list = list.slice(0, MAX);
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) { /* localStorage disabled — silent */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', track);
  } else {
    track();
  }
})();


/* ===============================================================
   MÓDULO: mkrv-render — Sección Vistos Recientemente (.mkrv)
   Lee localStorage.mkRecentlyViewed, hace fetch /products/{h}.js
   y renderiza cards simples en el grid.
   =============================================================== */
(function () {
  var KEY = 'mkRecentlyViewed';
  var priceFmt = null;
  try {
    priceFmt = new Intl.NumberFormat('es-CL', {
      style: 'currency', currency: 'CLP', maximumFractionDigits: 0
    });
  } catch (e) { priceFmt = null; }

  function formatPrice(cents) {
    var pesos = Math.round((cents || 0) / 100);
    if (priceFmt) return priceFmt.format(pesos);
    return '$' + pesos.toLocaleString('es-CL');
  }

  function buildCard(p) {
    var a = document.createElement('a');
    a.className = 'mkrv__card';
    a.href = p.url;
    a.setAttribute('role', 'listitem');
    var img = p.featured_image || (p.images && p.images[0]) || '';
    // Shopify permite sufijo _400x en la URL para obtener versión redimensionada
    if (img) img = img.replace(/(\.\w+)(\?.*)?$/, '_400x$1$2');
    var priceCents = p.price_min !== undefined ? p.price_min : p.price;
    var title = String(p.title || '').replace(/</g, '&lt;');
    var alt = String(p.title || '').replace(/"/g, '&quot;');

    a.innerHTML =
      '<div class="mkrv__img-wrap">' +
        (img ? '<img class="mkrv__img" src="' + img + '" alt="' + alt + '" loading="lazy">' : '') +
      '</div>' +
      '<div class="mkrv__body">' +
        '<div class="mkrv__title">' + title + '</div>' +
        '<div class="mkrv__price">' + formatPrice(priceCents) + '</div>' +
      '</div>';
    return a;
  }

  function initAllMkrv(scope) {
    var root = (scope && scope.querySelectorAll) ? scope : document;
    root.querySelectorAll('[data-mkrv]').forEach(function (widget) {
      if (widget.dataset.mkrvInit === '1') return;
      widget.dataset.mkrvInit = '1';

      var grid = widget.querySelector('[data-mkrv-grid]');
      var emptyMsg = widget.querySelector('[data-mkrv-empty]');
      if (!grid) return;

      var max = parseInt(widget.getAttribute('data-mkrv-max'), 10) || 8;
      var current = widget.getAttribute('data-mkrv-current') || '';

      var list;
      try {
        list = JSON.parse(localStorage.getItem(KEY) || '[]');
        if (!Array.isArray(list)) list = [];
      } catch (e) { list = []; }

      list = list.filter(function (h) { return h && h !== current; }).slice(0, max);

      if (list.length === 0) {
        if (emptyMsg) {
          emptyMsg.hidden = false;
          widget.classList.add('mkrv--show-empty');
        }
        return;
      }

      Promise.all(list.map(function (handle) {
        return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })).then(function (products) {
        var valid = products.filter(Boolean);
        if (valid.length === 0) {
          if (emptyMsg) {
            emptyMsg.hidden = false;
            widget.classList.add('mkrv--show-empty');
          }
          return;
        }
        var frag = document.createDocumentFragment();
        valid.forEach(function (p) { frag.appendChild(buildCard(p)); });
        grid.appendChild(frag);
        widget.classList.add('mkrv--has-items');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAllMkrv(); });
  } else {
    initAllMkrv();
  }
  document.addEventListener('shopify:section:load', function (e) { initAllMkrv(e.target); });
})();

/* ===============================================================
   MÓDULO: facturación cliente (ex x_facturacion.js)
   Toggle #solicita-factura-check → muestra #seccion-factura-campos
   y persiste los inputs [attributes[...]] en cart attributes.
   =============================================================== */
(function () {
  'use strict';

  function syncFacturaCliente() {
    var check = document.getElementById('solicita-factura-check');
    var box = document.getElementById('seccion-factura-campos');
    if (!check || !box) return;

    var isVisible = check.checked;
    var targetDisplay = isVisible ? 'flex' : 'none';
    if (box.style.display !== targetDisplay) {
      box.style.display = targetDisplay;
      box.querySelectorAll('input').forEach(function (i) { i.required = isVisible; });
    }
  }

  function saveAttributesCliente() {
    var box = document.getElementById('seccion-factura-campos');
    if (!box) return;

    var attributes = {};
    box.querySelectorAll('input').forEach(function (input) {
      var m = input.name.match(/attributes\[(.*?)\]/);
      if (m) attributes[m[1]] = input.value;
    });

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    });
  }

  document.addEventListener('click', function (e) {
    if (e.target && e.target.id === 'solicita-factura-check') syncFacturaCliente();
  });

  var timeoutCliente;
  document.addEventListener('input', function (e) {
    if (e.target && e.target.name && e.target.name.indexOf('attributes') !== -1) {
      clearTimeout(timeoutCliente);
      timeoutCliente = setTimeout(saveAttributesCliente, 800);
    }
  });

  // Polling de seguridad para componentes dinámicos de Shopify
  setInterval(syncFacturaCliente, 600);
})();

/* ===============================================================
   MÓDULO: slider fix (ex x_sliderfix.js)
   Oculta .mi-slider por defecto para evitar flash antes de que el
   slider se inicialice.
   =============================================================== */
(function () {
  var css = '.mi-slider { opacity: 0; visibility: hidden; }';
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
  head.appendChild(style);
})();

/* ===============================================================
   MÓDULO: WhatsApp flotante (ex snippet x-whatsapp)
   Config: window.mkConfig.whatsapp (renderizado desde theme.liquid
   con settings globales del tema).
   CSS: .mk-whatsapp-float en mk.css.liquid
   =============================================================== */
(function () {
  var cfg = (window.mkConfig && window.mkConfig.whatsapp) || null;
  if (!cfg || !cfg.enabled || !cfg.number) return;

  function inject() {
    if (document.querySelector('.mk-whatsapp-float')) return;

    var number = String(cfg.number).replace(/[\s+\-]/g, '');
    var msgTemplate = cfg.message || '¡Hola! vengo desde la {url} ¿me pueden ayudar?';
    var currentUrl = location.origin + location.pathname;
    var message = msgTemplate.replace('{url}', currentUrl);
    var href = 'https://wa.me/' + number + '?text=' + encodeURIComponent(message);

    var a = document.createElement('a');
    a.className = 'mk-whatsapp-float';
    a.href = href;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    a.setAttribute('aria-label', 'Contactar por WhatsApp');
    a.innerHTML = '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M16 0c-8.837 0-16 7.163-16 16 0 2.825 0.737 5.607 2.137 8.048l-2.137 7.952 7.933-2.127c2.42 1.37 5.173 2.127 8.067 2.127 8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 29.467c-2.482 0-4.908-0.646-7.07-1.87l-0.507-0.292-5.245 1.407 1.408-5.244-0.292-0.508c-1.207-2.100-1.862-4.53-1.862-7.027 0-7.51 6.123-13.6 13.6-13.6s13.6 6.123 13.6 13.6-6.123 13.6-13.6 13.6zM21.803 18.142c-0.397-0.197-2.348-1.158-2.713-1.29s-0.628-0.197-0.893 0.197c-0.265 0.397-1.025 1.29-1.257 1.555s-0.463 0.298-0.86 0.1c-0.397-0.197-1.673-0.617-3.187-1.966-1.177-1.050-1.973-2.347-2.205-2.743s-0.025-0.61 0.173-0.808c0.177-0.177 0.397-0.463 0.595-0.695s0.265-0.397 0.397-0.662c0.132-0.265 0.066-0.497-0.033-0.695s-0.893-2.152-1.223-2.948c-0.322-0.776-0.649-0.67-0.893-0.683-0.231-0.012-0.496-0.015-0.76-0.015s-0.695 0.099-1.058 0.497c-0.364 0.397-1.388 1.357-1.388 3.31s1.421 3.84 1.619 4.104c0.197 0.265 2.784 4.251 6.745 5.962 0.942 0.407 1.677 0.65 2.25 0.833 0.95 0.301 1.814 0.258 2.496 0.157 0.762-0.114 2.348-0.96 2.678-1.887s0.33-1.723 0.231-1.887c-0.099-0.165-0.364-0.265-0.76-0.463z" fill="currentColor"/></svg>';
    document.body.appendChild(a);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }
})();


/* ===============================================================
   === SECTION: mk-collection-carousel-vertical (mkcv) ===
   Auto-init multi-instancia. Prev/Next + progress bar de paginacion.
   Scoped por [data-mkcv-id] para no colisionar entre secciones.
   =============================================================== */
(function () {
  function initMkcv(root) {
    if (!root || root.dataset.mkcvInit === '1') return;
    root.dataset.mkcvInit = '1';

    var scroller = root.querySelector('[data-mkcv-scroller]');
    var prev = root.querySelector('[data-mkcv-prev]');
    var next = root.querySelector('[data-mkcv-next]');
    var progress = root.querySelector('.mkcv__pagination-progress');
    if (!scroller || !prev || !next) return;

    function slideStep() {
      var slide = scroller.querySelector('.mkcv__slide');
      if (!slide) return scroller.clientWidth;
      var gap = parseFloat(getComputedStyle(scroller).columnGap || getComputedStyle(scroller).gap) || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    function updateProgress() {
      var max = scroller.scrollWidth - scroller.clientWidth;
      var pct = max > 0 ? (scroller.scrollLeft / max) * 100 : 0;
      var trackPct = Math.max(0, Math.min(100 - 30, pct * 0.7));
      if (progress) progress.style.setProperty('--mkcv-progress', trackPct + '%');
      prev.toggleAttribute('disabled', scroller.scrollLeft <= 1);
      next.toggleAttribute('disabled', scroller.scrollLeft >= max - 1);
    }

    prev.addEventListener('click', function () {
      scroller.scrollBy({ left: -slideStep(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      scroller.scrollBy({ left: slideStep(), behavior: 'smooth' });
    });

    scroller.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress);
    updateProgress();
  }

  function initAllMkcv(scope) {
    (scope || document).querySelectorAll('[data-mkcv]').forEach(initMkcv);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAllMkcv(); });
  } else {
    initAllMkcv();
  }

  // Theme editor: re-init cuando se recarga una section
  document.addEventListener('shopify:section:load', function (e) {
    if (e && e.target) initAllMkcv(e.target);
  });
})();


/* ===============================================================
   === SECTION: mk-image-comparison (mkic) ===
   Before/After con handle draggable. Pointer events (mouse + touch).
   Multi-instancia, scoped por [data-mkic-id].
   =============================================================== */
(function () {
  /** @param {HTMLElement} root */
  function initMkic(root) {
    if (!root || root.dataset.mkicInit === '1') return;
    root.dataset.mkicInit = '1';

    var wrapperMaybe = /** @type {HTMLElement | null} */ (root.querySelector('[data-mkic-wrapper]'));
    var handleMaybe = /** @type {HTMLElement | null} */ (root.querySelector('[data-mkic-handle]'));
    if (!wrapperMaybe || !handleMaybe) return;
    var w = /** @type {HTMLElement} */ (wrapperMaybe);
    var h = /** @type {HTMLElement} */ (handleMaybe);

    var dragging = false;

    /** @param {number} pct */
    function setValue(pct) {
      pct = Math.max(0, Math.min(100, pct));
      root.style.setProperty('--mkic-value', String(pct));
      h.setAttribute('aria-valuenow', String(Math.round(pct)));
    }

    /** @param {{clientX: number}} evt */
    function pctFromEvent(evt) {
      var rect = w.getBoundingClientRect();
      if (!rect.width) return 50;
      var x = evt.clientX - rect.left;
      return (x / rect.width) * 100;
    }

    /** @param {PointerEvent | {clientX: number, pointerId?: number | null}} evt */
    function onDown(evt) {
      dragging = true;
      root.classList.add('is-dragging');
      var pid = /** @type {any} */ (evt).pointerId;
      if (pid != null && w.setPointerCapture) {
        try { w.setPointerCapture(pid); } catch (e) {}
      }
      setValue(pctFromEvent(evt));
    }
    /** @param {PointerEvent | {clientX: number}} evt */
    function onMove(evt) {
      if (!dragging) return;
      setValue(pctFromEvent(evt));
    }
    /** @param {PointerEvent | {pointerId?: number | null}} evt */
    function onUp(evt) {
      if (!dragging) return;
      dragging = false;
      root.classList.remove('is-dragging');
      var pid = /** @type {any} */ (evt).pointerId;
      if (pid != null && w.releasePointerCapture) {
        try { w.releasePointerCapture(pid); } catch (e) {}
      }
    }

    if (window.PointerEvent) {
      w.addEventListener('pointerdown', onDown);
      w.addEventListener('pointermove', onMove);
      w.addEventListener('pointerup', onUp);
      w.addEventListener('pointercancel', onUp);
      w.addEventListener('pointerleave', onUp);
    } else {
      w.addEventListener('mousedown', /** @type {any} */ (onDown));
      window.addEventListener('mousemove', /** @type {any} */ (onMove));
      window.addEventListener('mouseup', /** @type {any} */ (onUp));
      w.addEventListener('touchstart', /** @param {TouchEvent} e */ function (e) {
        var t = e.touches[0];
        if (t) onDown({ clientX: t.clientX, pointerId: null });
      }, { passive: true });
      w.addEventListener('touchmove', /** @param {TouchEvent} e */ function (e) {
        var t = e.touches[0];
        if (t) onMove({ clientX: t.clientX });
      }, { passive: true });
      w.addEventListener('touchend', function () { onUp({}); });
    }

    h.addEventListener('keydown', /** @param {KeyboardEvent} e */ function (e) {
      var current = parseFloat(getComputedStyle(root).getPropertyValue('--mkic-value')) || 50;
      var step = e.shiftKey ? 10 : 1;
      if (e.key === 'ArrowLeft')  { setValue(current - step); e.preventDefault(); }
      if (e.key === 'ArrowRight') { setValue(current + step); e.preventDefault(); }
      if (e.key === 'Home')       { setValue(0);   e.preventDefault(); }
      if (e.key === 'End')        { setValue(100); e.preventDefault(); }
    });
  }

  /** @param {ParentNode} [scope] */
  function initAllMkic(scope) {
    (scope || document).querySelectorAll('[data-mkic]').forEach(/** @param {Element} el */ function (el) {
      initMkic(/** @type {HTMLElement} */ (el));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAllMkic(); });
  } else {
    initAllMkic();
  }
  document.addEventListener('shopify:section:load', /** @param {Event} e */ function (e) {
    if (e && e.target) initAllMkic(/** @type {ParentNode} */ (e.target));
  });
})();


/* ===============================================================
   === SECTION: mk-sedes-home (mksh) ===
   Carrusel horizontal de sedes con prev/next. Multi-instancia.
   =============================================================== */
(function () {
  /** @param {HTMLElement} root */
  function initMksh(root) {
    if (!root || root.dataset.mkshInit === '1') return;
    root.dataset.mkshInit = '1';

    var scrollerMaybe = /** @type {HTMLElement | null} */ (root.querySelector('[data-mksh-scroller]'));
    var prevMaybe = /** @type {HTMLElement | null} */ (root.querySelector('[data-mksh-prev]'));
    var nextMaybe = /** @type {HTMLElement | null} */ (root.querySelector('[data-mksh-next]'));
    if (!scrollerMaybe || !prevMaybe || !nextMaybe) return;
    var sc = /** @type {HTMLElement} */ (scrollerMaybe);
    var prevBtn = /** @type {HTMLElement} */ (prevMaybe);
    var nextBtn = /** @type {HTMLElement} */ (nextMaybe);

    function slideStep() {
      var card = sc.querySelector('.mksh__card');
      if (!card) return sc.clientWidth;
      var gap = parseFloat(getComputedStyle(sc).columnGap || getComputedStyle(sc).gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function updateNav() {
      var max = sc.scrollWidth - sc.clientWidth;
      prevBtn.toggleAttribute('disabled', sc.scrollLeft <= 1);
      nextBtn.toggleAttribute('disabled', sc.scrollLeft >= max - 1);
    }

    prevBtn.addEventListener('click', function () { sc.scrollBy({ left: -slideStep(), behavior: 'smooth' }); });
    nextBtn.addEventListener('click', function () { sc.scrollBy({ left: slideStep(), behavior: 'smooth' }); });
    sc.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);
    updateNav();
  }

  /** @param {ParentNode} [scope] */
  function initAllMksh(scope) {
    (scope || document).querySelectorAll('[data-mksh]').forEach(/** @param {Element} el */ function (el) {
      initMksh(/** @type {HTMLElement} */ (el));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAllMksh(); });
  } else {
    initAllMksh();
  }
  document.addEventListener('shopify:section:load', /** @param {Event} e */ function (e) {
    if (e && e.target) initAllMksh(/** @type {ParentNode} */ (e.target));
  });
})();